/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { NoMatchAlert } from '../no-match-alert/NoMatchAlert';
import { HdButton } from '../../../components';
import { HdSupportButton } from '../../../support/components/support-button/SupportButton';

export interface NoEntityTypeAlertProps {
  suggestionContext: { name: string; value: string };
  actionHandler?: Function;
  isEntityType?: boolean;
}

export function NoEntityTypeAlert(props: NoEntityTypeAlertProps) {
  const { suggestionContext, isEntityType = true } = props;

  return (
    <NoMatchAlert
      titleComponent={TitleComponent}
      titleComponentProps={{
        suggestionContext,
        isEntityType
      }}
      subTextComponent={SubTextComponent}
      subTextComponentProps={{
        suggestionContext,
        isEntityType
      }}
      actionsComponent={isEntityType ? ActionComponent : undefined}
      actionsComponentProps={props}
    />
  );
}

function TitleComponent({
  suggestionContext,
  isEntityType
}: Omit<NoEntityTypeAlertProps, 'actionHandler'>) {
  return (
    <>
      No {suggestionContext.name} {isEntityType ? 'Type' : ''} Found 😞
    </>
  );
}

function SubTextComponent({
  suggestionContext,
  isEntityType
}: Omit<NoEntityTypeAlertProps, 'actionHandler'>) {
  return (
    <>
      No matching {suggestionContext.name} {isEntityType ? 'Type' : ''} found for the above search
      criteria
    </>
  );
}

function ActionComponent({
  suggestionContext,
  actionHandler,
  isEntityType
}: NoEntityTypeAlertProps) {
  return (
    <HdSupportButton
      tag='button'
      dataId={`${suggestionContext.name}${isEntityType ? 'Type' : ''}-suggest`}
      Component={HdButton}
      onClick={() => actionHandler()}
    >
      Connect with our Support Team
    </HdSupportButton>
  );
}
